import React from 'react';
import PropTypes from 'prop-types';
import { PageHeader } from 'components/common';

/**
 * Shared, professional form scaffolding for booking request forms
 * (car booking + travel request). The header is the app-wide PageHeader
 * (hero variant); section cards give an accented body.
 */

// Thin alias kept for existing call sites — new code should use PageHeader.
export const FormHero = ({ icon, title, subtitle, onBack }) => (
  <PageHeader icon={icon} title={title} subtitle={subtitle} onBack={onBack} />
);

FormHero.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onBack: PropTypes.func,
};

// Accented section card: slate header strip with a blue icon chip + title.
// NOTE: no `overflow-hidden` here — it would clip open react-datepicker / react-select
// popups that extend past the section, leaving empty "ghost" boxes.
export const FormSection = ({ icon: Icon, title, desc, children, className = '' }) => (
  <section className={`tw-mb-4 tw-border tw-border-solid tw-border-slate-200 tw-rounded-lg ${className}`}>
    <div className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-2.5 tw-bg-slate-50 tw-border-b tw-border-solid tw-border-slate-200 tw-rounded-t-lg">
      <span className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded tw-bg-blue-100 tw-text-blue-600 tw-flex-shrink-0">
        {Icon && <Icon size={15} />}
      </span>
      <div className="tw-min-w-0">
        <h6 className="tw-mb-0 tw-font-semibold tw-text-slate-800 tw-text-sm tw-leading-tight">{title}</h6>
        {desc && <p className="tw-mb-0 tw-mt-0.5 tw-text-xs tw-text-slate-400 tw-truncate">{desc}</p>}
      </div>
    </div>
    <div className="tw-p-4">{children}</div>
  </section>
);

FormSection.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
